<template>
  <div class="row">
    <!--  用户列表  -->
    <div class="flex xs12">
      <va-card :title="'用户'+ $route.query.userUid +'的账号类型'">
        <div class="row align--start mb-1">
          <div class="flex md12 xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">账号类型：</va-button>
              <va-button class="mb-2" flat :color="computedColor(null)" v-on:click="handleAccountTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                flat
                :color="computedColor(t.CODE)"
                v-on:click="handleAccountTypeChange(t.CODE)"
                v-for="t in accountTypes"
                :key="t.CODE"
              >{{t.TEXT}}</va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md6 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button outline color="gray" :to='{path:`updateUser/${$route.query.userUid}`}'>返回用户个人资料</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="loginInfos"
          :loading="loading"
          api-mode
        >
          <template slot="accountType" slot-scope="props">
            <div>
              {{ computeAccountTypeColor(props.rowData.type).text }}
            </div>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>

import { ACCOUNT_TYPES } from '@/utils/constants'
import loginInfoApi from '@/api/loginInfo'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      loginInfos: [],
      loading: true,
      totalCount: 0,
      accountType: null,
      accountTypes: ACCOUNT_TYPES,
      uid: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:accountType',
          title: '账号类型',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'account',
          title: '账号',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listLoginInfo()
  },
  methods: {
    listLoginInfo () {
      this.loading = true
      if (this.$route.query.userUid == null) return
      const params = {
        uid: this.$route.query.userUid,
        accountType: this.accountType,
      }
      loginInfoApi.listLoginInfo(params).then(response => {
        this.loginInfos = response.loginInfos
        this.loginInfos.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalCount = response.totalCount
        this.loading = false
      }).catch(error => alert(error.msg))
    },
    handleAccountTypeChange (accountType) {
      this.accountType = accountType
      this.listLoginInfo()
    },
    computedColor: function (accountType) {
      return this.accountType === accountType ? 'info' : 'gray'
    },
    computeAccountTypeColor: function (accountType) {
      const data = {
        color: 'info',
        text: '全部',
      }
      ACCOUNT_TYPES.map(x => {
        if (accountType === x.CODE) {
          data.text = x.TEXT
        }
      })
      return data
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
